export function isNullOrUndefined(value : string){
    if(value == null || value == undefined){
        return true;
    } 

    return false;
}